import React, { useState, useEffect } from "react";
// import { useAtom } from "jotai";
import { FaChevronDown, FaChevronUp, FaPlus } from "react-icons/fa";
// import RemainderPopup from "./RemainderPopup";
// import {
//   showPopupAtom,
//   popupTaskAtom,
// } from "../_helper/constant/constant-atom";

export default function Today() {
    const storedTasks = JSON.parse(localStorage.getItem("tasks"));
    const [tasks, setTasks] = useState(storedTasks || []);
    const [inputValue, setInputValue] = useState("");
    const mainColorStyle = { backgroundColor: "var(--main-color)" };
    const darkGreyColorStyle = { backgroundColor: "var(--darkgrey-color)" };

    //   const [, setShowPopup] = useAtom(showPopupAtom);
    //   const [, setPopupTask] = useAtom(popupTaskAtom);

    // Define formatTime before using it
    const formatTime = (date) =>
        date.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
        });

    // const [ctime, setCtime] = useState(formatTime(new Date()));

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         setCtime(formatTime(new Date()));
    //     }, 1000);

    //     return () => clearInterval(intervalId);
    // }, []);

    //   useEffect(() => {
    //     const storedTasks = localStorage.getItem("tasks");
    //     if (storedTasks) {
    //       setTasks(JSON.parse(storedTasks));
    //     }
    //   }, []);

    useEffect(() => {
        localStorage.setItem("tasks", JSON.stringify(tasks));
    }, [tasks]);

    const handleInputChange = (e) => setInputValue(e.target.value);

    const handleInputKeyPress = (e) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            const newTask = {
                id: Date.now(),
                title: capitalizeFirstLetter(inputValue),
                isCollapsed: true,
                isCompleted: false,
                notes: "",
                priority: "None",
                date: "",
                time: "",
            };
            setTasks([...tasks, newTask]);
            setInputValue("");
        }
    };

    const handleInputButtonPress = (e) => {
        const newTask = {
            id: Date.now(),
            title: capitalizeFirstLetter(inputValue),
            isCollapsed: true,
            isCompleted: false,
            notes: "",
            priority: "None",
            date: "",
            time: "",
        };
        setTasks([...tasks, newTask]);
        setInputValue("");
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const toggleCollapse = (taskId) => {
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId
                    ? { ...task, isCollapsed: !task.isCollapsed }
                    : task
            )
        );
    };

    const toggleCompletion = (taskId) => {
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId
                    ? { ...task, isCompleted: !task.isCompleted }
                    : task
            )
        );
    };

    const deleteTask = (taskId) => {
        setTasks((prevTasks) => prevTasks.filter((task) => task.id !== taskId));
    };

    const handleDateChange = (taskId, e) => {
        const newDate = e.target.value;
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId ? { ...task, date: newDate } : task
            )
        );
    };

    const handleTimeChange = (taskId, e) => {
        const newTime = e.target.value;
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId
                    ? {
                          ...task,
                          time: formatTime(
                              new Date(`1970-01-01T${newTime}:00`)
                          ),
                      }
                    : task
            )
        );
    };

    const handleNotesChange = (taskId, e) => {
        const newNotes = e.target.value;
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId ? { ...task, notes: newNotes } : task
            )
        );
    };

    const handlePriorityChange = (taskId, e) => {
        const newPriority = e.target.value;
        setTasks((prevTasks) =>
            prevTasks.map((task) =>
                task.id === taskId ? { ...task, priority: newPriority } : task
            )
        );
    };

    const checkTaskTime = (task) => {
        setTasks((prev) => {
            const selectedTask = prev?.findIndex((ele) => ele?.id === task?.id);
            const temp = [...prev];
            temp[selectedTask].isCollapsed = false;
            return temp;
        });
    };

    // useEffect(() => {
    //     tasks.map((task) => {
    //         checkTaskTime(task);
    //     });
    // }, [ctime, tasks]);

    return (
        <>
            {tasks.map((task) => (
                <div className="flex mt-4 md:mx-4 mx-4" key={task.id}>
                    <div
                        className={`w-full sm:w-96 md:w-2/3 lg:w-1/2 rounded overflow-hidden border border-gray-200 mb-4 ${
                            task.isCompleted ? "bg-gray-400" : "bg-white"
                        }`}>
                        <div
                            className="px-6 py-4 cursor-pointer flex justify-between items-center"
                            onClick={() => toggleCollapse(task.id)}>
                            <div className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2"
                                    checked={task.isCompleted}
                                    onChange={() => toggleCompletion(task.id)}
                                />
                                <div
                                    className={`font-bold text-lg mb-1 ${
                                        task.isCompleted
                                            ? "line-through text-gray-800"
                                            : ""
                                    }`}>
                                    {task.title}
                                </div>
                            </div>
                            {task.isCollapsed ? (
                                <FaChevronDown
                                    className={`text-gray-700 ${
                                        task.isCompleted ? "text-gray-500" : ""
                                    }`}
                                />
                            ) : (
                                <FaChevronUp
                                    className={`text-gray-700 ${
                                        task.isCompleted ? "text-gray-500" : ""
                                    }`}
                                />
                            )}
                        </div>
                        {task.isCollapsed && (
                            <div
                                className={`px-6 py-4 ${
                                    task.isCompleted
                                        ? "text-gray-500"
                                        : "text-black"
                                }`}>
                                <div className="border border-gray-250 mb-5"></div>
                                <div className="flex flex-col md:flex-row md:space-x-4">
                                    <div className="w-full md:w-1/2 mb-4 md:mb-0">
                                        <div className="mb-4">
                                            <div className="font-bold">
                                                Notes
                                            </div>
                                            <textarea
                                                className="w-full h-52 border rounded p-2"
                                                disabled={task.isCompleted}
                                                value={task.notes}
                                                onChange={(e) =>
                                                    handleNotesChange(
                                                        task.id,
                                                        e
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full md:w-1/2">
                                        <div className="mb-4">
                                            <div className="font-bold">
                                                Due Date & Time
                                            </div>
                                            <div className="flex flex-col md:flex-row md:space-x-2 mt-2 space-y-2 md:space-y-0">
                                                <input
                                                    type="date"
                                                    className="border rounded p-2 w-full md:flex-1"
                                                    value={task.date}
                                                    onChange={(e) =>
                                                        handleDateChange(
                                                            task.id,
                                                            e
                                                        )
                                                    }
                                                    disabled={task.isCompleted}
                                                />
                                                <input
                                                    type="time"
                                                    className="border rounded p-2 w-full md:flex-1"
                                                    value={task.time}
                                                    onChange={(e) =>
                                                        handleTimeChange(
                                                            task.id,
                                                            e
                                                        )
                                                    }
                                                    disabled={task.isCompleted}
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="font-bold">
                                                Priority
                                            </div>
                                            <select
                                                className="border rounded p-2 w-full"
                                                value={task.priority}
                                                onChange={(e) =>
                                                    handlePriorityChange(
                                                        task.id,
                                                        e
                                                    )
                                                }
                                                disabled={task.isCompleted}>
                                                <option>None</option>
                                                <option>Low</option>
                                                <option>Medium</option>
                                                <option>High</option>
                                            </select>
                                        </div>
                                        <div className="mt-4 flex justify-end space-x-2">
                                            <button
                                                className="border-gray-600 rounded py-2 px-4  text-gray-600"
                                                disabled={task.isCompleted}
                                                onClick={() =>
                                                    checkTaskTime(task)
                                                }
                                                style={mainColorStyle}>
                                                Notify Me
                                            </button>
                                            <button
                                                className="border rounded py-2 px-4  text-gray-600"
                                                onClick={() =>
                                                    deleteTask(task.id)
                                                }
                                                style={darkGreyColorStyle}>
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
            <div className="flex mt-5 sm:mx-0 md:mx-4 mx-4">
                <div className="flex items-center border rounded p-2 w-full sm:w-96 md:w-2/3 lg:w-fit">
                    <button className="mr-2">
                        <FaPlus />
                    </button>
                    <input
                        type="text"
                        placeholder="Add a Task"
                        className="border-none focus:outline-none flex-grow"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyPress={handleInputKeyPress}
                    />
                </div>
                <button
                    className=" text-gray-800 focus:outline-none  focus:ring-4 focus:ring-gray-100 font-medium rounded-md text-md px-5 py-2.5 ml-2"
                    onClick={handleInputButtonPress}
                    style={mainColorStyle}>
                    Add
                </button>
            </div>
        </>
    );
}
